import styled, { css } from 'styled-components'
import { colors, media, updatedMedia } from 'client/styles'

import { LoginNavigatorBase } from 'src/comps/LoginNavigator/styles'
import { LoginButtonBase } from 'src/comps/LoginButton/styles'

export const UserActions = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  justify-content: flex-end;
  position: relative;
  gap: 8px;

  ${media.tablet} {
    ${LoginNavigatorBase} {
      position: absolute;
      inset-block-start: 38px;
      z-index: 20;
      background-color: ${colors.white};
    }

    ${LoginNavigatorBase} {
      inset-inline-start: calc(100% - 170px);
      width: 200px;
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);
    }
  }
  ${updatedMedia.tablet} {
    gap: 16px;
  }
`

export const RightSideWrapper = styled.div<{ isSearch?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  ${({ isSearch }) =>
    isSearch &&
    css`
      ${LoginButtonBase} {
        margin-inline-end: 0;
      }
    `}
  ${updatedMedia.tablet} {
    gap: 16px;
  }

  ${updatedMedia.desktop} {
    height: 40px;
  }
`
